export default __webpack_public_path__ + "static/media/shearts@2x.de902b8a.png";